// extracted by mini-css-extract-plugin
export default {"summary":"SummarySection_summary__0DnfN"};